import React from "react";
import { Tooltip } from "@mui/material";
import TooltipImg from '../assets/images/tooltip-info.svg'

const ToolTip = ({ info, width, height }) => {
  return (
    <Tooltip title={info} placement="bottom-start" arrow>
      <img
        src={TooltipImg}
        width={width || 16}
        height={height || 16}
        alt=""
        style={{ cursor: 'pointer' }}
      />
    </Tooltip>
  );
};

export default ToolTip;
